export const Roles = {
    Admin: 'admin',
    Manager: 'manager',
    Employee : 'employee',
    Client : 'client'    
}